<template>
  <v-card
    class="mx-auto parent-list-overflow rounded-card card-shadow"
    height="450"
    max-height="450"
  >
    <v-card-title class="headline text--primary font-weight-bold">
      Solicitações pendentes
      <v-btn v-if="hasRoleRequisicao"
             small link
             color="primary"
             class="ml-2 normal-btn-text elevation-0"
             to="/cadastro-requisicao">
        <v-icon x-small>mdi-plus</v-icon>Solicitação
      </v-btn>
    </v-card-title>
    <v-card-text class="text--primary list-overflow">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <v-list class="mt-3" v-if="!loading && requisicoes.length">
        <template v-for="requisicao in requisicoes">
          <v-list-item link :to="`requisicao/${requisicao.id}`" :key="requisicao.id">
            <v-list-item-content>
              <v-row dense no-gutters>
                <v-col cols="12" sm="6">
                  <px-situacao-requisicao-icon :situacao="requisicao.situacao"/>
                  {{ requisicao.identificador }}
                </v-col>
                <v-col cols="12" sm="3" class="text-center">
                  {{ requisicao.quantidadeProdutos }}
                  <div>
                    produto(s)
                  </div>
                </v-col>
                <v-col cols="12" sm="3" class="text-center">
                  <px-requisicao-urgencia :urgencia="requisicao.urgencia"/>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="`div-${requisicao.id}`"/>
        </template>
      </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      requisicoes: [],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleRequisicao']),
  },
  methods: {
    getRequisicoes() {
      this.loading = true;
      RequisicoesService.getRequisicoesList({
        query: 'situacao in ("RECEBIDA", "EM_COTACAO", "EM_COMPRA") order by createdIn desc',
      })
        .then(({ data }) => {
          this.requisicoes = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getRequisicoes();
  },
};
</script>

<style scoped>
.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 395px;
  max-height: 395px;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
